import React from "react"
import { formatToCurrency } from "../../../helpers/FormatHelper";
import { useState } from "react";
import NumberInput from "../../shared/NumberInput";
import { useEffect } from "react";
import LoadingBox from "../../shared/LoadingBox";
import AlertBox from "../../shared/AlertBox";
import { getConfirmation, save, sendConfirmation } from "./NettingService";
import NettingViewOrder from "./NettingViewOrder";

const  NettingSummaryScreen = ({customerID, customerName, buyCurrency, selectedBuyCcy, ordersBuy, ordersSell, balanceBuy, balanceSell, onBackNettingInfo, onCancelSummary, isView, selectedNettingID}) => {

    const [orderBuySelections, setOrderBuySelections] = useState([]);
    const [orderSellSelections, setOrderSellSelections] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showConfirmationEmail, setShowConfirmationEmail] = useState(false);
    const [messageEmail, setMessageEmail] = useState(false);

    const [orderID, setOrderID] = useState(0);
    const [showOrderDetail, setShowOrderDetail] = useState(false);
    const [saved, setSaved] = useState(false);
    const [nettingID, setNettingID] = useState(0);


    useEffect(() => {
        const selectedBuyOrders = ordersBuy.filter(
            order => order.apply || order.applyBalance
        );

        const selectedSellOrders = ordersSell.filter(
            order => order.apply || order.applyBalance
        );
        setOrderBuySelections(selectedBuyOrders);
        setOrderSellSelections(selectedSellOrders);
    },[ordersBuy, ordersSell]);

    useEffect(()=> {
        if(isView && selectedNettingID > 0)
        {
            setNettingID(selectedNettingID);
        }

    },[isView, selectedNettingID])

    const onBack = () => {
        onBackNettingInfo();
    }

    const onCancel = () => {
        onCancelSummary();
    }

    const onSave = () => {
        if(orderBuySelections.length > 0 && orderSellSelections.length > 0)
        {
            setShowConfirmation(true);
        }
        else
        {
            setAlertMessage('Please select at least one order from both Buy and Sell orders to proceed with netting.');
            setAlertTitle('Error');
            setShowAlert(true);
        }
    }

    const closeAlert = () => {
        setShowAlert(false);
    }

    const closeConfirmation = () => {
        setShowConfirmation(false);
    }   

    const yesConfirmation = async() => {
        setShowConfirmation(false);
        setLoading(true);
        
        const responseSave = await save(customerID, buyCurrency, orderBuySelections, orderSellSelections, totalBuyOriginal, totalSellOriginal);
        setLoading(false);    
        if(responseSave.Success)
        {
            setNettingID(responseSave.NettingID);
            setSaved(true);
            setMessageEmail(`${responseSave.Message} Are you sure you want to send this netting confirmation?`);
            setShowConfirmationEmail(true);
        }
        else{        
            setAlertTitle(responseSave.Title);
            setAlertMessage(responseSave.Message);
            setShowAlert(true);
        }
        
    }

     const totalBuyOriginal = orderBuySelections.reduce(
        (total, order) => Number(total) + Number(order.TotalNetOrderNumber),
        0
    );

    const totalSellOriginal = orderSellSelections.reduce(
        (total, order) => Number(total) + Number(order.TotalNetOrderNumber),
        0
    );

    const totalBuyToApply = orderBuySelections.reduce(
        (total, order) =>
            total + (order.apply ? Number(order.amountToApply) : 0),
        0
    );

    const totalSellToApply = orderSellSelections.reduce(
        (total, order) =>
            total + (order.apply ? Number(order.amountToApply) : 0),
        0
    );

    const closeOrderDetail = () => {
        setShowOrderDetail(false);
        setOrderID(0);
    }

    const showDetail = (orderNo) => {
        setOrderID(orderNo);
        setShowOrderDetail(true);
    }

    const downloadConfirmation = async() =>{
            setLoading(true);
            const responseConfirmation = await getConfirmation(nettingID);
            setLoading(false);
    
            if(responseConfirmation?.Success)
            {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(responseConfirmation.File);
                link.download = responseConfirmation.FileName;
                link.click();
            }
            else
            {
                setAlertTitle(responseConfirmation.Title);
                setAlertMessage(responseConfirmation.Message);
                setShowAlert(true);
            }
        }

    const sendConfirmationEmail = () =>{
        setMessageEmail("Are you sure you want to send this netting confirmation?");
        setShowConfirmationEmail(true);
    }
    
    const yesConfirmationEmail = async() =>{
        setShowConfirmationEmail(false);
        setLoading(true);
        const responseSave = await sendConfirmation(nettingID);
        setAlertTitle(responseSave.Title);
        setAlertMessage(responseSave.Message);
        setLoading(false);
        setShowAlert(true);
    }
    
     const closeConfirmationEmail =() =>{
        setShowConfirmationEmail(false);
    }

 const getBuyOrdersList = () => {
     return (
         <table className="netting-table">
             <thead>
                 <tr>
                     <th colSpan="2"></th>
                     <th>Total</th>
                     <th>{formatToCurrency(totalBuyOriginal)}</th>
                     <th>{formatToCurrency(totalBuyToApply)}</th>
                 </tr>
                 <tr>
                     <th>Apply<br />Balance</th>
                     <th>Apply</th>
                     <th>Order Id</th>
                     <th>Original<br />Amount</th>
                     <th colSpan="2">To Apply</th>
                 </tr>
             </thead>
 
             <tbody>
                 {orderBuySelections.map(order => {
                     const key = order.BNOrderNo;
                     const amountToApply = order.amountToApply ?? '';
 
                     return (
                         <tr key={key}>
                             <td className="checkbox-cell">
                                 <input
                                     type="checkbox"
                                     checked={order.applyBalance || false}
                                     disabled={true}
                                 />
                             </td>
 
                             <td className="checkbox-cell">
                                 <input
                                     type="checkbox"
                                     checked={order.apply || false}
                                     disabled={true}
                                 />
                             </td>
 
                             <td>
                                 <a
                                     href="#"
                                     onClick={(e) => {
                                        e.preventDefault();
                                        showDetail(key);
                                    }}
                                 >
                                     {key}
                                 </a>
                             </td>
 
                             <td className="amount">
                                 {formatToCurrency(order.TotalNetOrderNumber)}
                             </td>
 
                             <td className="amount">
                                 <NumberInput
                                     id={`txt-buyapplyamount-${key}`}
                                     key={`txt-buyapplyamount-${key}`}
                                     className="amount-input"
                                     value={amountToApply}
                                     disabled={true}
                                     scale={2}
                                     type="Currency"
                                 />
                             </td>
                         </tr>
                     );
                 })}
             </tbody>
         </table>
     );
 };
 
 
     
 const getSellOrdersList = () => {
     return (
         <table className="netting-table">
             <thead>
                 <tr>
                     <th colSpan="2"></th>
                     <th>Total</th>
                     <th>{formatToCurrency(totalSellOriginal)}</th>
                     <th>{formatToCurrency(totalSellToApply)}</th>
                 </tr>
                 <tr>
                     <th>Apply<br />Balance</th>
                     <th>Apply</th>
                     <th>Order Id</th>
                     <th>Original<br />Amount</th>
                     <th>To Apply</th>
                 </tr>
             </thead>
 
             <tbody>
                 {orderSellSelections.map(order => {
                     const key = order.BNOrderNo;
                     const amountToApply = order.amountToApply ?? '';
 
                     return (
                         <tr key={key}>
                             <td className="checkbox-cell">
                                 <input
                                     type="checkbox"
                                     checked={order.applyBalance || false}
                                     disabled={true}
                                 />
                             </td>
 
                             <td className="checkbox-cell">
                                 <input
                                     type="checkbox"
                                     checked={order.apply || false}
                                     disabled={true}
                                 />
                             </td>
 
                             <td>
                                 <a
                                     href="#"
                                     onClick={(e) => {
                                        e.preventDefault();
                                        showDetail(key);
                                    }}
                                 >
                                     {key}
                                 </a>
                             </td>
 
                             <td className="amount">
                                 {formatToCurrency(order.TotalNetOrderNumber)}
                             </td>
 
                             <td className="amount">
                                 <NumberInput
                                     id={`txt-sellapplyamount-${key}`}
                                     key={`txt-sellapplyamount-${key}`}
                                     className="amount-input"
                                     value={amountToApply}
                                     disabled={true}
                                     scale={2}
                                     type="Currency"
                                 />
                             </td>
                         </tr>
                     );
                 })}
             </tbody>
         </table>
     );
 };
    return (
        <div className="uk-grid">
            <div  className="uk-width-1-2 uk-form-controls">
                <label className="uk-form-label">{'Customer:'}</label>
                <input className="uk-input" id="customer-name" value={customerName} type="text" disabled={true} />
            </div>
            <div  className="uk-width-1-4 uk-form-controls">
                <label className="uk-form-label">{'Settlement Currency:'}</label>
                <input className="uk-input" id="ccy-name" value={selectedBuyCcy} type="text" disabled={true} />            
            </div>
            

            <div  className="uk-width-1-1 uk-form-controls" style={{marginTop:'20px'}}>
                <div className="uk-grid">
                    <div className="uk-width-1-2">
                        <div  className="uk-grid">
                             <div className="uk-width-1-2">
                                 <h5>{`Our Buy Orders `}</h5> 
                             </div>
                             <div className="uk-width-1-2" style={{paddingRight:'10%',textAlign:'right'}}>
                                 {balanceBuy !== 0 && (
                                     <h6>Balance: {formatToCurrency(balanceBuy)}</h6>
                                 )}
                             </div>
                        </div>
                        {getBuyOrdersList()}
                        
                    </div>
                    <div className="uk-width-1-2">
                        <div  className="uk-grid">
                            <div className="uk-width-1-2">
                                <h5>{`Customer Orders `}</h5> 
                            </div>
                            <div className="uk-width-1-2" style={{paddingRight:'10%',textAlign:'right'}}>
                                {balanceSell !== 0 && (
                                    <h6>Balance: {formatToCurrency(balanceSell)}</h6>
                                )}
                            </div>
                        </div>
                        {getSellOrdersList()}
                    </div>
                </div>
            </div>

            <div  className="uk-width-1-1 uk-form-controls" style={{marginTop:'20px'}}>
               {!saved && !isView &&
                    <button className="uk-button uk-button-green" onClick={onBack}>
                        {'Back'}
                    </button>
                }
                {!saved && !isView &&
                    <button className="uk-button uk-button-green" onClick={onSave}>
                        {'Save'}
                    </button>
                }
                <button className="uk-button uk-button-green" onClick={onCancel}>
                    {'Cancel'}
                </button>
                {isView && 
                    <button className="uk-button uk-button-green" onClick={downloadConfirmation}>
                        {'Download'}
                    </button>
                }
                {isView && 
                    <button className="uk-button uk-button-green" onClick={sendConfirmationEmail}>
                        {'Send Confirmation'}
                    </button>
                }
            </div>

            <LoadingBox loading={loading}/>
            <AlertBox open={showAlert} onClose={closeAlert} title={alertTitle} message={alertMessage} type="Ok" okClick={closeAlert} />
            <AlertBox open={showConfirmation} title={'Save Confirmation'}
                            message="Are you sure you want to save this netting?"
                            type="Yes/No"
                            onClose={closeConfirmation}
                            yesClick={yesConfirmation}
                            noClick={closeConfirmation}/>
            <AlertBox open={showConfirmationEmail} title={'Send Confirmation'}
                                        message={messageEmail}
                                        type="Yes/No"
                                        onClose={closeConfirmationEmail}
                                        yesClick={yesConfirmationEmail}
                                        noClick={closeConfirmationEmail}/>
            
            <NettingViewOrder orderID={orderID} showOrder={showOrderDetail} onCloseOrderDetail={closeOrderDetail}/>
        </div>
    );
}

export default NettingSummaryScreen;